import { render, staticRenderFns } from "./BarsIcon.vue?vue&type=template&id=4241604a&"
import script from "./BarsIcon.vue?vue&type=script&lang=js&"
export * from "./BarsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports